import { render, staticRenderFns } from "./OpenTimeSetting.vue?vue&type=template&id=22672cb7&"
import script from "./OpenTimeSetting.vue?vue&type=script&lang=js&"
export * from "./OpenTimeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports